export default __webpack_public_path__ + "static/media/wave.c130b739.svg";